import "./DashboardHome.scss";
import ButtonGradient from "../ButtonGradient/ButtonGradient";
import dashboardImage from "../../assets/images/laptop-compare.png";
import stadiumPitchImage from "../../assets/images/applewood stadium pitch.png";
import { Link } from "react-router-dom";
import { useDealershipContext } from "../../contexts/dealershipContext";
import { ReactComponent as MaeCoreLogoYellow } from "../../assets/logos/Mae-Minimized-Logo-Yellow.svg";
import { useRecordingSessionContext } from "../../contexts/recordingSessionContext";
import { MicStatus } from "../MicStatus/MicStatus";
import morreyPromiseImg from "../../assets/images/morrey-one-price-experience.png";
import morreyVolvoPromiseImg from "../../assets/images/morrey-one-price-experience-blue.png";
function DashboardHome() {
  const { dealershipImgUrl, applewoodRedTheme, baseURL, dealershipId } =
    useDealershipContext();

  const { recordingEnabled, audioStatus } = useRecordingSessionContext();

  const landingFillerImage =
    dealershipId === "morreyvolvocarsburnaby"
      ? morreyVolvoPromiseImg
      : dealershipId?.startsWith("morrey")
        ? morreyPromiseImg
        : applewoodRedTheme
          ? stadiumPitchImage
          : dashboardImage;

  return (
    <>
      {(recordingEnabled === "1" ||
        recordingEnabled === "2" ||
        recordingEnabled === "3") && <MicStatus status={audioStatus} />}
      <div className="landing_page">
        <div className="product_info">
          <img
            className="product_info__dealership_logo"
            src={dealershipImgUrl}
            alt=""
          />
          <h1
            className="product_info__main_text"
            style={{
              fontFamily: applewoodRedTheme
                ? "Montserrat Medium"
                : "Poppins Medium",
            }}
          >
            {" "}
            {dealershipId?.startsWith("morrey")
              ? "Welcome and thank you for choosing Morrey! have you been here before?"
              : "Your Customized Car Journey Starts Here"}
          </h1>

          {applewoodRedTheme ? (
            ""
          ) : (
            <div className="product_info__creator_section">
              <div className="product_info__text" style={{ fontWeight: "400" }}>
                Powered By
              </div>
              <div className="product_info__logo">
                <MaeCoreLogoYellow />
              </div>
            </div>
          )}
          <br></br>
          <div className="product_info__buttons">
            <Link to={`${baseURL}matchmaker-quiz?audio=${recordingEnabled}`}>
              {dealershipId === "morreyvolvocarsburnaby" ? (
                <ButtonGradient text="Start Check-in" style={"blue"} />
              ) : applewoodRedTheme ? (
                <ButtonGradient text="Start Check-in" style={"red"} />
              ) : (
                <ButtonGradient text="Start Check-in" />
              )}
            </Link>
          </div>
        </div>
        <div
          className={`landing_page__filler ${dealershipId === "morreyvolvocarsburnaby" ? "blue-gradient" : applewoodRedTheme ? "red-gradient" : ""}`}
        >
          <img
            className="landing_page__filler--image"
            src={landingFillerImage}
            alt=""
            style={{ marginRight: applewoodRedTheme ? "7em" : "-3em" }}
          />
        </div>
      </div>
    </>
  );
}

export default DashboardHome;
